import useApiCall from "@hooks/Shared/useApiCall";
import { ISpacesResponse } from "@interfaces/Spaces/SpacesResponse";

const useGetSpaces = (projectId: string) =>
  useApiCall<ISpacesResponse>({
    url: `/projects/${projectId}/spaces`,
  });

export default useGetSpaces;
